export const navigateToTermsOfService = () => {
  window.open("https://genira.com/terms-of-service/", "_blank", "noopener");
};

export const navigateToPrivacyPolicy = () => {
  window.open("https://genira.com/privacy-policy/", "_blank", "noopener");
};

export const navigateToAiUsagePolicy = () => {
  window.open("https://genira.com/data-processing-agreement/", "_blank", "noopener");
};
